module.exports = __webpack_public_path__ + "static/media/product-icon-active.6fbb9022.svg";